import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Gmail/Google OAuth failure (never an app-session failure).
export const isGmailReconnectError = (e) => {
  const r = e?.response;
  if (!r) return false;
  if ((r.headers?.['x-gmail-status'] || '') === 'reconnect_required') return true;
  const detail = typeof r.data?.detail === 'string' ? r.data.detail : '';
  return (r.status === 409 || r.status === 401) && /gmail|mailbox|reconnect/i.test(detail);
};

const startOAuth = (path) => {
  const token = localStorage.getItem('token');
  if (!token) { toast.error('Please sign in again before connecting Gmail'); return; }
  window.location.href = `${API}${path}?token=${encodeURIComponent(token)}`;
};

// Shows "Gmail credentials expired — Reconnect" for the shared and/or personal mailbox.
export const GmailReconnectBanner = ({ sharedEmail, personalEmail, isAdmin }) => {
  if (!sharedEmail && !personalEmail) return null;
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 p-3 flex items-start gap-3" data-testid="gmail-reconnect-banner">
      <AlertTriangle size={18} className="text-amber-700 mt-0.5 shrink-0" />
      <div className="flex-1 text-sm text-amber-900">
        <div className="font-semibold">Gmail credentials expired — reconnect required</div>
        <div className="mt-0.5">
          Google stopped accepting the saved sign-in for{' '}
          <span className="font-mono">{[sharedEmail, personalEmail].filter(Boolean).join(' and ')}</span>.
          You are still logged in to the app; email features resume once the mailbox is reconnected.
          {sharedEmail && !isAdmin && ' Ask an admin to reconnect the shared mailbox.'}
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        {sharedEmail && isAdmin && (
          <Button size="sm" onClick={() => startOAuth('/oauth/gmail/start')} data-testid="gmail-reconnect-shared-btn" className="gap-1.5">
            <RefreshCw size={14} /> Reconnect shared
          </Button>
        )}
        {personalEmail && (
          <Button size="sm" variant="outline" onClick={() => startOAuth('/oauth/gmail/personal/start')} data-testid="gmail-reconnect-personal-btn" className="gap-1.5">
            <RefreshCw size={14} /> Reconnect mine
          </Button>
        )}
      </div>
    </div>
  );
};
